module.exports = __webpack_public_path__ + "static/media/FirstResponders2.96c2a1e1.png";